<script>
    import SearchField from "./search-field.vue";
    import TextField from "../common/text-field.vue";

    export default {
        name: "search-field-container",
        props: {
            name: String,
            autocomplete: {
                type: String,
                default: "off"
            },
            role: {
                type: String,
                default: "presentation"
            }
        },
        components: {TextField, SearchField}
    }
</script>

<template>
    <div class="d-flex flex-row align-center">
        <div class="mr-2" style="max-width: 280px; width: 15vw;">
            <search-field
                :name="name"
                :autocomplete="autocomplete"
                :role ="role">
            </search-field>
        </div>
        <slot />
    </div>
</template>

<style scoped>

</style>
